import * as React from "react";
import { EmployeeDto } from "Api/Api";
import styled from "styled-components";
import { useResource, Resources } from "Translations/Resources";
import { Typography } from "@material-ui/core";
import { formatDate } from "Utils/DateUtils";
import { sortPositions } from "Components/HumanResources/Employees/EmployeeEdit/EmployeeEditPositions/EmployeeEditPositions";

type Props = {
  employee: EmployeeDto;
};

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledPositions = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  gap: ${props => props.theme.spacing(1, 0.625)};
  justify-content: flex-start;
`;

export const EmployeeDetailPositions: React.FunctionComponent<Props> = props => {
  const { employee } = props;
  const { t } = useResource();

  return (
    <>
      <StyledWrapper className={"row"}>
        <div className={"row-title"}>
          {t(Resources.HumanResources.Employees.Detail.Positions)}
        </div>
        <div>
          <StyledPositions>
            {sortPositions(employee.positions)?.map(position => (
              <React.Fragment key={position.employeePositionID}>
                <Typography align={"right"}>
                  {formatDate(position.dateFrom)}
                </Typography>
                <Typography>-</Typography>
                <Typography>{position.positionName}</Typography>
              </React.Fragment>
            ))}
          </StyledPositions>
        </div>
      </StyledWrapper>
      <hr />
    </>
  );
};
